export default __webpack_public_path__ + "img/logout-icon.c01215c4.svg";